[
  {
    "code": "Choice",
    "name": "Choice"
  },
  {
    "code": "Lucky",
    "name": "Lucky"
  },
  {
    "code": "eeze",
    "name": "eeze(new)"
  },
  {
    "code": "IVI",
    "name": "IVI"
  },
  {
    "code": "Playtech",
    "name": "Playtech"
  }
]
